import React, {useContext} from 'react';
import {OrdersSadanContext} from "../OrdersSadanContext";

function PaymentCode(props) {
  const helper = useContext(OrdersSadanContext);
  const setData = helper.setData
  const data = helper.data

  return (<div className="div__group__input_select mx-2">
    <label  htmlFor={"rnd1"}>
      کد پرداخت
    </label>
    <input
      type="number"
      name="firstCode"
      value={data.paymentCode}
      onChange={(e) => setData({paymentCode: e.target.value})}
    />

  </div>);
}

export default PaymentCode;